<template>
  <div class="invoice_mini">
    <app-info :order="repair" />

    <h5>Customer : {{ repair.name | capitalize }}</h5>
    <table class="table">
      <tbody>
        <tr>
          <th class="text-left">
            Device :
          </th>
          <td>{{ repair.deviceName | capitalize }}</td>
        </tr>
        <tr>
          <th class="text-left">
            Serial #
          </th>
          <td>{{ repair.sNumber | capitalize }}</td>
        </tr>
        <tr v-if="repair.imei">
          <th class="text-left">
            Imei #
          </th>
          <td>{{ repair.imei | capitalize }}</td>
        </tr>
        <tr>
          <th class="text-left">
            Issue :
          </th>
          <td>{{ repair.issue | capitalize }}</td>
        </tr>
      </tbody>
    </table>
    <v-row class="mt-0 pt-0">
      <v-col cols="4">
        <img
          :src="repair.qrcode"
          class="qrcode"
        >
      </v-col>
      <v-col cols="8">
        <table class="table">
          <tbody>
            <tr>
              <th>Charges</th>
              <td>{{ repair.charges | currency }}</td>
            </tr>
            <tr>
              <th>Tax ({{ repair.taxRate }} %)</th>
              <td>{{ repair.taxAmount | currency }}</td>
            </tr>
            <tr>
              <th>PrePaid</th>
              <td>{{ repair.prePaid | currency }}</td>
            </tr>
            <tr>
              <th>Due Amount</th>
              <td>{{ repair.due | currency }}</td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
    <terms-conditions />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Terms from "../common/Terms.vue";
import AppInfo from "../common/ComInfo.vue";
export default {
  components: {
    "app-info": AppInfo,
    "terms-conditions": Terms,
  },
  data() {
    return {
      repair: {},
    };
  },
  computed: {
    ...mapGetters({
      configs: "configs/overall",
    }),
  },
  mounted() {
    window.axios.get("/repair/" + this.$route.params.id).then((response) => {
      this.$data.repair = response.data.repair;
      Event.$emit("printSize");
      Event.$emit("loadTerms", "repairTerms");
    });
  },
};
</script>
<style type="text/css" scoped="">
.qrcode {
  width: 70px;
  height: 70px;
}
</style>
